import { useEffect } from "react";
import { useLayoutTitle } from "../context/LayoutTitleContext.jsx";
import { openBotSupportChat } from "../lib/telegramWebAppAuth.js";
import styles from "./HelpPage.module.css";

export default function HelpPage() {
  const { setPageTitle } = useLayoutTitle();

  useEffect(() => {
    setPageTitle("Помощь");
    return () => setPageTitle(null);
  }, [setPageTitle]);

  return (
    <div className={`${styles.wrap} ${styles.wrapChoice}`}>
      <div className={styles.choiceHero}>
        <h2 className={styles.h2}>Нужна помощь?</h2>
        <p className={styles.lead}>
          Напишите нам — чат с поддержкой откроется прямо в боте, ответим по вопросам
          сервиса и раздач.
        </p>
        <button
          type="button"
          className={styles.contactBtn}
          onClick={() => openBotSupportChat()}
        >
          <span className={styles.choiceCardTitle}>Написать в поддержку</span>
          <span className={styles.choiceCardSub}>чат откроется в боте</span>
        </button>
      </div>
    </div>
  );
}
